import { cn } from "@/lib/utils";
import type { ToolField } from "@/data/toolForms";

export const ToolFormField = ({
  field,
  value,
  onChange,
}: {
  field: ToolField;
  value: string;
  onChange: (v: string) => void;
}) => {
  const baseInput =
    "w-full rounded-input border border-hairline bg-background px-3 py-2 text-[0.85rem] text-foreground outline-none transition-colors placeholder:text-muted-foreground/70 focus:border-foreground";

  const id = `field-${field.name}`;
  return (
    <div>
      <label htmlFor={id} className="mb-1.5 block text-[0.75rem] font-medium text-ink-mid">
        {field.label}
        {field.required && <span className="ml-0.5 text-yellow-dark">*</span>}
      </label>
      {field.type === "textarea" ? (
        <textarea
          id={id}
          required={field.required}
          rows={field.rows ?? 3}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={field.placeholder}
          className={cn(baseInput, "resize-y leading-relaxed")}
        />
      ) : field.type === "select" ? (
        <select
          id={id}
          required={field.required}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className={cn(baseInput, "appearance-none bg-[length:14px] bg-[right_0.75rem_center] bg-no-repeat pr-9")}
          style={{
            backgroundImage:
              "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='%23666'%3E%3Cpath d='M5.25 7.5L10 12.25L14.75 7.5' stroke='%23666' stroke-width='1.5' fill='none'/%3E%3C/svg%3E\")",
          }}
        >
          <option value="">Select…</option>
          {field.options?.map((o) => (
            <option key={o} value={o}>
              {o}
            </option>
          ))}
        </select>
      ) : (
        <input
          id={id}
          type={field.type === "number" ? "number" : field.type === "date" ? "date" : "text"}
          required={field.required}
          min={field.min}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={field.placeholder}
          className={baseInput}
        />
      )}
      {field.helper && (
        <p className="mt-1 text-[0.7rem] font-light text-muted-foreground">{field.helper}</p>
      )}
    </div>
  );
};
